module.exports = __webpack_public_path__ + "static/media/30OIOS2.fc19e82f.jpg";